import { Box, Chip } from "@mui/material";
import { getOrderStatusColor } from "../../utils/Constant";

export default function OrderTableStatusCell({ rowData }: any) {
  const color = getOrderStatusColor(rowData.orderStatus);
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "inherit" }}>
      <Chip
        sx={{ backgroundColor: color, color: "white" }}
        label={rowData.orderStatus}
      />
    </Box>
  );
}
